/**
 * Reseller rates — add-exception page — eagerly registers the file route and its
 * `?scope=&targetId=` search validator; the page component and its atom/RPC/design
 * imports are deferred to `new.lazy.tsx` so they never land in the always-loaded
 * `main` chunk (CLA-645).
 *
 * The two scope literals are declared inline here (mirroring
 * `agents/$agentId_.configure.tsx`) so the eager twin imports nothing from the
 * design module.
 *
 * Nests under `admin_/resellers/route.tsx`, whose `requireAdmin` `beforeLoad`
 * gate already runs ahead of this screen — this route adds no auth check.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

/**
 * Validate the `?scope=&targetId=` search carrying the pre-selected add-exception
 * target. A known scope (`customer` / `agent`) passes through; anything else is
 * dropped so the page defaults to customer scope + the first candidate.
 *
 * @since 1.0.0
 */
export const validateAddExceptionSearch = (
  search: Record<string, unknown>,
): { scope?: "customer" | "agent"; targetId?: string } => {
  const scope = search["scope"] === "customer" || search["scope"] === "agent" ? search["scope"] : undefined;
  const targetId = typeof search["targetId"] === "string" ? search["targetId"] : undefined;
  return { ...(scope ? { scope } : {}), ...(targetId ? { targetId } : {}) };
};

export const Route = createFileRoute("/clawinstall/admin_/resellers/$customerId/rates/new")({
  validateSearch: validateAddExceptionSearch,
});
